module.exports = __webpack_public_path__ + "img/andres-iniesta.dfcf7dfe.png";